/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityPrivacyPolicyOverrideItem
 */
export interface ControlEntityPrivacyPolicyOverrideItem {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPrivacyPolicyOverrideItem
     */
    policy_link: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPrivacyPolicyOverrideItem
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEntityPrivacyPolicyOverrideItem
     */
    scan_location?: string;
}

/**
 * Check if a given object implements the ControlEntityPrivacyPolicyOverrideItem interface.
 */
export function instanceOfControlEntityPrivacyPolicyOverrideItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "policy_link" in value;

    return isInstance;
}

export function ControlEntityPrivacyPolicyOverrideItemFromJSON(json: any): ControlEntityPrivacyPolicyOverrideItem {
    return ControlEntityPrivacyPolicyOverrideItemFromJSONTyped(json, false);
}

export function ControlEntityPrivacyPolicyOverrideItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityPrivacyPolicyOverrideItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'policy_link': json['policy_link'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'scan_location': !exists(json, 'scan_location') ? undefined : json['scan_location'],
    };
}

export function ControlEntityPrivacyPolicyOverrideItemToJSON(value?: ControlEntityPrivacyPolicyOverrideItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'policy_link': value.policy_link,
        'reason': value.reason,
        'scan_location': value.scan_location,
    };
}

